export const reportPrefix = '/report'
